var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefresh = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.688 8.688 6.562 6.562C5.62 5.62 4 6.287 4 7.62v6.88c0 .831.669 1.5 1.5 1.5h6.881c1.338 0 2.006-1.619 1.063-2.563l-1.925-1.925A11.96 11.96 0 0 1 20 8c6.625 0 12 5.375 12 12s-5.375 12-12 12c-2.55 0-4.912-.794-6.856-2.15a2.004 2.004 0 0 0-2.788.494 1.999 1.999 0 0 0 .494 2.787A15.994 15.994 0 0 0 20 36c8.837 0 16-7.163 16-16 0-8.838-7.163-16-16-16A15.952 15.952 0 0 0 8.687 8.688Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refresh.ed669a522c786b8e9578f6ff414032cd.svg";